import { element } from './element';

function prepareDialog() {
  if (!document.createElement('dialog').showModal) {
    return import('./dialogPolyfill');
  }
  return Promise.resolve();
}


const OPEN = 'open';
const CLOSE = 'close';

function checkValid() {
  if (!this.dialog) {
    throw new Error('ModalDialog already destroyed');
  }
}

function isOpen() {
  return !!this.dialog && this.dialog.hasAttribute(OPEN);
}

async function waitFor(dialog) {
  if (dialog instanceof Promise) {
    await dialog;
  } else {
    await Promise.resolve(); // always return a promise
  }
}

function getContents(header, title, content) {
  const fragment = document.createDocumentFragment();
  fragment.append(
    element('div.header-wrapper', [
      header ? element(
        'div.overlay-header',
        title ? element('h1.h4', title) : '',
      ) : '',
      element('button.overlay-close-btn.close-medium.right', { type: 'button', 'aria-label': 'close dialog' }, ''),
    ]),
    element(
      `div.overlay-body${header ? '.header-visible' : ''}`,
      element('div.overlay-content-container', content),
    ),
  );

  return fragment;
}

class ModalDialog {
  constructor(options) {
    const {
      content = '',
      destroyOnClose = false,
      header = true,
      id,
      title = '',
    } = options;

    if (!id || typeof id !== 'string') {
      throw new Error('ModalDialog: property ID is required and must be a string.');
    }

    this.dialog = prepareDialog()
      .then(() => {
        const d = document.createElement('dialog');
        d.setAttribute('id', id);
        if (destroyOnClose) {
          d.addEventListener(CLOSE, () => {
            this.destroy();
          });
        }
        d.appendChild(getContents(header, title, content));
        d.querySelector('.header-wrapper button').addEventListener('click', () =>
          this.close());
        document.body.appendChild(d);
        // override the promise with the actual daialog element
        this.dialog = d;
      });
  }

  async open() {
    checkValid.call(this);

    await waitFor(this.dialog);

    if (!isOpen.call(this)) {
      this.dialog.showModal();
    }
  }

  async close() {
    checkValid.call(this);

    await waitFor(this.dialog);

    if (isOpen.call(this)) {
      this.dialog.close();
    }
  }

  async destroy() {
    await waitFor(this.dialog);

    if (this.dialog) {
      if (isOpen.call(this)) {
        // calling dialog.close directly
        // it is an async operation
        this.dialog.close();
      }

      this.dialog.remove();
      this.dialog = null;
    }
  }
}

export default ModalDialog;
